var render = function render(){var _vm=this,_c=_vm._self._c;return _c('map-mission',{ref:"map",attrs:{"uiid":_vm.uiid,"maptype":"mission"}})
}
var staticRenderFns = []

export { render, staticRenderFns }